import { COMPANY_STATUS } from '@companies/constants'

const defaultColDef = {
  menuTabs: [
    'filterMenuTab',
    'generalMenuTab',
    'columnsMenuTab',
  ],
  resizable: true,
  sortable: true,
  filter: true,
}

const columnDefs = [
  {
    'cellClass': 'number-cell text-muted',
    'field': 'id',
    'filter': 'number',
    'headerName': 'ID',
    'pinned': 'left',
    'width': 60,
    'sortable': true,
  },
  {
    'headerName': 'Company',
    'field': 'name',
    'cellRenderer': 'CompaniesLinkCellRenderer',
    'filterValueGetter': 'data.company',
    'filter': 'agTextColumnFilter',
    'minWidth': 220,
    'sortable': true,
  },
  {
    'headerName': 'Email',
    'field': 'email',
    'filter': 'agTextColumnFilter',
    'minWidth': 200,
    'sortable': false,
  },
  {
    'headerName': 'Address',
    'cellRenderer': 'AddressCellRenderer',
    'cellRendererParams': {
      'streetAddress': 'address',
      'city': 'city',
      'state': 'state',
      'zip': 'zip',
    },
    'minWidth': 150,
    'cellClass': 'multiline',
    'sortable': false,
  },
  {
    'headerName': 'Phone',
    'field': 'phone',
    'cellRenderer': 'PhoneCellRenderer',
    'minWidth': 120,
    'cellClass': 'multiline',
    'sortable': false,
  },
  {
    'headerName': 'Roles',
    'field': 'roles',
    'minWidth': 120,
    'sortable': false,
  },
  {
    'headerName': 'Status',
    'field': 'status',
    'cellRenderer': 'BadgeCellRenderer',
    'cellRendererParams': {
      'variant': {
        [COMPANY_STATUS.ENABLED]: 'success',
        [COMPANY_STATUS.DISABLED]: 'danger',
        [COMPANY_STATUS.PENDING]: 'warning',
      },
    },
    'minWidth': 100,
    'enableCellChangeFlash': true,
    'sortable': false,
  },
  {
    'cellRenderer': 'CompaniesActionsCellRenderer',
    'field': 'status',
    'filter': false,
    'headerName': 'Actions',
    'minWidth': 200,
    'pinned': 'right',
    'sortable': false,
    'suppressHeaderMenuButton': true,
    'enableCellChangeFlash': true,
  },
]

export const gridConfig = {
  defaultColDef,
  columnDefs,
  statusBar: {},
  pagination: true,
  apiSettings: {
    rowsUrl: '/CompanyManagement/api/v2/companies',
    noRowsMessage: 'No data to display',
  },
  // enabling be default to ensure consistency with vue2 version
  enableExportButton: true,
  enableMultirowSelect: false,
  enablePresets: false,
  // disabling until backend is resolved
  enableQuickFilter: false,
  showActiveFilters: true,
}
